module.exports = __webpack_public_path__ + "Roboto-Italic.de74c60991cd63c8b922.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/fonts/roboto/Roboto-Italic.ttf
// module id = 383
// module chunks = 2